import { useFetchEditableDashboards } from '@modules/dashboard/hooks';
import { EditableDashboardListItem } from '@modules/dashboard/types';
import AddIcon from '@mui/icons-material/Add';
import { Button, Divider, ListItem, ListItemText, Menu } from '@mui/material';
import { useState } from 'react';
import { AddAnalysisToDashboardList } from './AddAnalysisToDashboardList';
import { AddAnalysisToDashboardSearch } from './AddAnalysisToDashboardSearch';

interface AddAnalysisToDashboardMenuProps {
  menuAnchor: null | HTMLElement;
  onClose: () => void;
  onDashboardSelect: (dashboard: EditableDashboardListItem) => void;
  onAddToNewDashboard: () => void;
}

export const AddAnalysisToDashboardMenu = ({
  menuAnchor,
  onClose,
  onDashboardSelect,
  onAddToNewDashboard,
}: AddAnalysisToDashboardMenuProps) => {
  const [searchQuery, setSearchQuery] = useState('');

  const {
    editableDashboards,
    loading: isFetchingDashboards,
    fetchMore: fetchMoreEditableDashboards,
    hasNextPage,
  } = useFetchEditableDashboards({ query: searchQuery.trim() });

  const noDashboardsCreatedYet =
    !isFetchingDashboards && !editableDashboards.length && !searchQuery.trim();

  const isMenuOpen = Boolean(menuAnchor);

  return (
    <Menu
      anchorEl={menuAnchor}
      open={isMenuOpen}
      onClose={onClose}
      MenuListProps={{
        sx: { py: 0 },
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <ListItem>
        <ListItemText primary="Add to a Dashboard" />
      </ListItem>
      <Divider />
      {!noDashboardsCreatedYet && (
        <AddAnalysisToDashboardSearch
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />
      )}
      <AddAnalysisToDashboardList
        dashboards={editableDashboards}
        isFetchingDashboards={isFetchingDashboards}
        onDashboardSelect={onDashboardSelect}
        noDashboardsCreatedYet={noDashboardsCreatedYet}
        searchQuery={searchQuery}
        fetchMoreEditableDashboards={fetchMoreEditableDashboards}
        hasNextPage={hasNextPage}
      />
      <Divider />
      <Button
        size="medium"
        onClick={() => onAddToNewDashboard()}
        fullWidth
        startIcon={<AddIcon />}
        style={{ justifyContent: 'flex-start', padding: 12 }}
      >
        Add to a new Dashboard
      </Button>
    </Menu>
  );
};
